import { render, staticRenderFns } from "./DeactivateQuickLoginDialog.vue?vue&type=template&id=777049c0"
import script from "./DeactivateQuickLoginDialog.vue?vue&type=script&lang=ts"
export * from "./DeactivateQuickLoginDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports